import AppInputField from "components/shared/FormComponents/AppInputField";
import { useFormikContext } from "formik";
import { replacePlaceholders } from "helpers/common";
import { useEffect } from "react";

const QuestionWithTemplate = ({ question, fieldName, fieldData, preview }) => {
  const { setFieldValue, getFieldMeta } = useFormikContext();
  const fieldMeta = getFieldMeta(`${fieldName}.answer`);
  const fieldValue = fieldMeta.value;

  useEffect(() => {
    // Set the template value only during the initial render if the field is undefined or null
    if ((fieldValue === undefined || fieldValue === null) && question?.template) {
      const templateString = replacePlaceholders(question?.template, fieldData);
      setFieldValue(`${fieldName}.answer`, templateString);
    }
  }, [fieldValue, question?.template, fieldData, fieldName, setFieldValue]);

  return (
    preview ? <div>{fieldValue}</div> : <AppInputField
      name={`${fieldName}.answer`}
      placeholder={question.placeholder}
      fieldType={"textarea"}
      rows={4}
      className="form-control h-auto rounded-3 bg-white"
    />
  );
};

export default QuestionWithTemplate;